<template>
  <div class="mind-page">
    <!-- 话题墙 -->
    <div class="header-section">
      <div class="page-header">
        <h2 class="page-title">话题</h2>
      </div>
      <div class="topic-wall" v-if="columns.length">
        <div class="topic-row">
          <div v-for="t in row1" :key="t" class="topic-chip" :class="{ active: value === t }" @click="selectTopic(t)">{{ t }}</div>
        </div>
        <div class="topic-row" v-if="row2.length">
          <div v-for="t in row2" :key="t" class="topic-chip" :class="{ active: value === t }" @click="selectTopic(t)">{{ t }}</div>
        </div>
      </div>
      <div v-else class="topic-wall"><div class="topic-chip empty">加载中...</div></div>
      <div class="topic-count" v-if="value && list.length">{{ list.length }} 条</div>
    </div>

    <!-- 内容区 -->
    <div class="content-area" v-if="value">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
        :offset="50"
      >
        <div v-if="isEmpty" class="empty-state">
          <van-icon name="smile-comment-o" size="48" color="#c8c9cc" />
          <p>暂无内容</p>
        </div>

        <div v-for="item in list" :key="item.sumdate + item.topic" class="mind-card">
          <div class="card-date" @click="goToDate(item.sumdate)">{{ item.sumdate }}</div>
          <div class="card-body" v-html="item.context" />
        </div>
      </van-list>
    </div>

    <div v-if="!value" class="empty-state">
      <van-icon name="chat-o" size="48" color="#c8c9cc" />
      <p>选择一个话题开始浏览</p>
    </div>

    <div class="safe-bottom" />
  </div>
</template>

<script>
import {
  List, Cell, Step, Steps, Button, Row, Col, Icon, CellGroup, Picker, Popup, Field, Toast
} from "vant";

export default {
  components: {
    [List.name]: List, [Cell.name]: Cell, [CellGroup.name]: CellGroup,
    [Field.name]: Field, [Row.name]: Row, [Col.name]: Col, [Icon.name]: Icon,
    [Picker.name]: Picker, [Popup.name]: Popup, [Toast.name]: Toast
  },
  data() {
    return {
      value: "",
      columns: [],
      pageNum: 1,
      list: [],
      loading: false,
      finished: false,
      lastScrollTop: 0
    };
  },
  computed: {
    isEmpty() {
      return !this.loading && this.list.length === 0;
    },
    row1() {
      var mid = Math.ceil(this.columns.length / 2);
      return this.columns.slice(0, mid);
    },
    row2() {
      var mid = Math.ceil(this.columns.length / 2);
      return this.columns.slice(mid);
    }
  },
  methods: {
    goToDate(date) {
      this.$router.push({ name: 'hist', query: { date: date } });
    },
    selectTopic(t) {
      if (this.value === t) return;
      this.value = t;
      this.pageNum = 1;
      this.finished = false;
      this.list = [];
      this.loading = true;
      this.$https
        .fetchPost("/mind/page", { pageNum: this.pageNum++, topic: this.value })
        .then(result => {
          var data = result.data;
          this.list = data.list || [];
          this.loading = false;
          if (data.pageNumber >= data.totalPage) this.finished = true;
        })
        .catch(() => { this.loading = false; });
    },
    onLoad() {
      this.$https
        .fetchPost("/mind/page", { pageNum: this.pageNum++, topic: this.value })
        .then(result => {
          var data = result.data;
          for (var index in data.list) this.list.push(data.list[index]);
          this.loading = false;
          if (data.pageNumber >= data.totalPage) this.finished = true;
        });
    }
  },
  mounted() {
    Toast.loading({ mask: true, message: "加载中..." });
    var self = this;
    this.$https
      .fetchPost("/mind/topics", {})
      .then(result => {
        var data = result.data;
        for (var index in data) self.columns.push(data[index]["topic"]);
        Toast.clear();
        if (self.columns.length) self.selectTopic(self.columns[0]);
      })
      .catch(() => { Toast.clear(); });
  }
};
</script>

<style lang="less" scoped>
.mind-page {
  min-height: 100vh;
  background: #f2f2f7;
}

.header-section {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(242,242,247,.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
}
.page-header {
  padding: 12px 16px 0;
}
.page-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #000;
}
.topic-count {
  font-size: 13px;
  color: #8e8e93;
  padding: 0 16px 8px;
}
/* 话题墙 — iOS 风格 */
.topic-wall {
  padding: 6px 16px 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
}
.topic-row {
  display: flex;
  gap: 8px;
  padding: 4px 0;
}

.topic-chip {
  flex-shrink: 0;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 500;
  color: #3c3c43;
  background: rgba(60,60,67,0.06);
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  line-height: 1.4;

  &:active { transform: scale(0.96); }
  &.active {
    color: #fff;
    background: #007aff;
  }
  &.empty {
    color: #c7c7cc;
    cursor: default;
    background: transparent;
  }
}

.mind-card {
  margin: 8px 14px;
  padding: 14px 16px;
  background: rgba(255,255,255,.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-radius: 12px;

  .card-date {
    font-size: 12px;
    color: #007aff;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .card-body {
    font-size: 15px;
    color: #000;
    line-height: 1.7;
    word-break: break-all;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0;
  p {
    margin-top: 12px;
    color: #c7c7cc;
    font-size: 14px;
  }
}

.safe-bottom {
  height: 20px;
}
</style>
